/**
 * Enum defining options for user capabilities.
 */
export enum UserCapabilityOption {
    YES = "YES",
    NO = "NO",
    CONDITIONAL = "CONDITIONAL",
  }